<template>
  <div class="agree-modal-comp">
    <mv-modal :visible="visible">
      <template #content>
        <div class="agree-content">
          <div class="terms-text">
            <slot name="content"/>
          </div>
          <div v-if="mode === 'agree'">
            <mv-button
                class="mb-16"
                type="round-primary"
                text="common.agree"
                @click="actionAgree"
            />
            <div class="disagree-row" @click="actionDisagree">
              <button></button>
              <div class="row-text">{{ $t('common.disagree') }}</div>
            </div>
          </div>
          <div v-else>
            <mv-button
                class="mb-16"
                type="round-primary"
                text="common.confirm"
                @click="actionConfirm"
            />
          </div>
        </div>
      </template>
    </mv-modal>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import MvButton from '@/components/common/button/MvButton.vue';
import MvModal from '@/components/common/modal/MvModal.vue';

export default defineComponent({
  name: 'AgreeModalComp',
  emits: ['disagree', 'agree', 'update:visible', 'confirm'],
  props: {
    visible: {
      default: false,
    },
    mode: {
      default: 'agree'
    }
  },
  components: {
    MvButton,
    MvModal,
  },
  setup(props, context) {
    const actionDisagree = () => {
      context.emit('update:visible', false)
      context.emit('disagree')
    }

    const actionAgree = () => {
      context.emit('update:visible', false)
      context.emit('agree')
    }

    const actionConfirm = () => {
      context.emit('update:visible', false)
      context.emit('confirm')
    }

    return {
      actionDisagree,
      actionAgree,
      actionConfirm,
    }
  }
})
</script>
